<template>
  <div>
    <v-container class="pt-0 pb-5">
      <v-row>
        <v-col>
          <div class="pa-2 rounded elevation-1 bg-white">
            <v-btn color="primary-dark" @click="$router.go(-1)" density="compact" variant="outlined">
              <v-icon left>mdi-arrow-left</v-icon>
              Retour
            </v-btn>
            <div class="text-h6 mt-3 mb-4">Utiliser la Garantie Individuelle d'Annulation</div>
            <div>Votre inscription sera annulée, vous serez remboursé du prix du parcours</div>
            <v-row>
              <v-col class="d-flex">
                <v-btn v-if="!onload" class="sm-fullwidth mt-2 inscription_btn" color="primary-dark"
                  @click="display_confirm_dialog = true">Procéder au remboursement de {{ refund.amount_to_refund
                  }}€</v-btn>
                <v-progress-circular v-else indeterminate color="primary-dark"></v-progress-circular>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="display_confirm_dialog" width="500" max-width="100%" scroll-strategy="none">
      <v-card>
        <v-card-text>
          <div class="text-h6">Confirmer le remboursement</div>
          <p>
            Vous êtes sur le point de procéder à un remboursement de <b>{{ refund.amount_to_refund }}€</b> pour votre
            inscription, qui sera annulée. Cette action est irréversible.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary-dark" text @click="display_confirm_dialog = false">Annuler</v-btn>
          <v-btn color="primary-dark" text @click="proceed_to_refund()">Confirmer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="display_response_dialog" width="500" max-width="100%" scroll-strategy="none">
      <v-card>
        <v-card-text>
          <div class="text-h6">Votre demande de remboursement</div>
          <div v-if="response_refund == null">Une erreur est survenue. Veuillez contacter le support
            Sportips.</div>
          <div v-if="response_refund == false">{{ refund.error }}</div>
          <div v-else>
            <div v-if="!response_refund.refund_possible">
              Le remboursement n'a pas pu être effectuée. Les fonds sur la commande associée à cette inscription sont
              insuffisants.
              <div class="field_label">Montant remboursé : {{ response_refund.amount_refunded }}€</div>
              <div class="field_label">Montant restant à rembourser : {{ response_refund.amount_not_refunded }}€</div>
            </div>
            <div v-else>
              <div v-if="response_refund.amount_to_refund != response_refund.amount_refunded">
                Le remboursement n'a pas pu être effectué intégralement. Le remboursement d'une des transactions a
                echoué (problème de communication banque...).
                <div class="field_label">Montant remboursé : {{ response_refund.amount_refunded }}€</div>
                <div class="field_label">Montant restant à rembourser : {{ response_refund.amount_not_refunded }}€</div>
              </div>
              <div v-else>
                Le remboursement a été effectué avec succès.
                <div class="field_label">Montant remboursé : {{ response_refund.amount_refunded }}€</div>
              </div>
            </div>
            <div>Un email de confirmation vient de vous être envoyé.</div>
          </div>


        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary-dark" text @click="handle_close_response_dialog()">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Inscription from "@/classes/Fiche_Coureur/Inscription.class";
import Inscription_Refund from "@/classes/Refund/Inscription_Refund.class.js";
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
  data() {
    return {
      display_confirm_dialog: false,
      display_response_dialog: false,
      onload: false,
      response_refund: {},
      inscription: new Inscription(),
      refund: new Inscription_Refund(),
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    async proceed_to_refund() {
      this.response_refund = {};
      this.display_confirm_dialog = false;
      this.onload = true;
      this.response_refund = await this.refund.user_refund_with_gia();

      this.display_response_dialog = true;
      this.onload = false;
    },
    handle_close_response_dialog() {
      this.display_response_dialog = false;
      this.$router.push({ name: "FicheCoureur" });
    },
    async get_inscription() {
      this.inscription.id = this.$route.params.id_inscription;
      await this.inscription.get();
      if (!this.inscription.gia) {
        this.$router.push({ name: "FicheCoureur" });
      }
      this.refund.action = "refund_with_gia";
      this.refund.init(this.inscription, {
        has_gia_speciale: this.mainStore.module.has_gia_speciale,
        date_debut_evenement: this.mainStore.module.evenement.date_debut,
      });
    },
  },

  async created() {
    await this.get_inscription();
  },
};
</script>

<style lang="scss" scoped></style>